document.addEventListener('click',e=>{const open=(sel)=>document.querySelector(sel)?.classList.add('open'),close=(sel)=>document.querySelector(sel)?.classList.remove('open');if(e.target.closest('[data-menu]'))open('[data-menu-panel]');if(e.target.closest('[data-menu-close]'))close('[data-menu-panel]');if(e.target.closest('[data-cart-open]'))open('[data-cart]');if(e.target.closest('[data-cart-close]'))close('[data-cart]')});

/* Homepage quick-add only. Product pages use the theme's native product-form AJAX flow. */
document.addEventListener('submit',async e=>{
  const form=e.target;
  if(!(form instanceof HTMLFormElement)||!form.matches('.product-shelf form[action="/cart/add"]'))return;
  e.preventDefault();
  const drawer=document.querySelector('cart-drawer');
  const data=new FormData(form);
  if(drawer&&typeof drawer.getSectionsToRender==='function'){
    data.append('sections',drawer.getSectionsToRender().map(section=>section.id));
    data.append('sections_url',window.location.pathname);
  }
  try{
    const response=await fetch(window.routes?.cart_add_url||'/cart/add.js',{
      method:'POST',
      headers:{'X-Requested-With':'XMLHttpRequest'},
      body:data
    });
    const result=await response.json();
    if(!response.ok||result.status)throw new Error(result.description||'Unable to add item to cart');
    if(drawer&&typeof drawer.renderContents==='function')drawer.renderContents(result);
    else window.location.href=window.routes?.cart_url||'/cart';
  }catch(error){
    console.error('DRVORIA quick add failed:',error);
  }
});

/* Reliable mobile navigation binding for storefront and theme editor. */
(()=>{if(window.__drvoriaMenuFallback)return;window.__drvoriaMenuFallback=true;const setMenu=open=>{const p=document.querySelector('[data-menu-panel]'),t=document.querySelector('[data-menu]');if(!p)return;p.classList.toggle('open',open);p.setAttribute('aria-hidden',open?'false':'true');if(t)t.setAttribute('aria-expanded',open?'true':'false');document.documentElement.classList.toggle('drvoria-menu-open',open)};document.addEventListener('click',e=>{if(e.target.closest('[data-menu]')){e.preventDefault();setMenu(true)}else if(e.target.closest('[data-menu-close]')){e.preventDefault();setMenu(false)}},true);document.addEventListener('keydown',e=>{if(e.key==='Escape')setMenu(false)});})();